import axios from 'axios'
import Const from '@/helper/const'

export default {
  getAddressFromCep (params) {
    return axios({
      method: 'get',
      url: `${Const.API_VIACEP}/${params}/json/`,
      headers: {
        'Content-Type': 'application/json'
      }
    })
  }
}
